import SlugInput from './SlugInput';

export default SlugInput;
